<template>
  <div>
  <h1>Créer / éditer une Affaire</h1>
  <b-form :id="`${getInputId}-form-${_uid}`" @submit="editCreate($event)">
    <b-form-group label="Veuillez entrer le N° Oasice pour créer ou éditer l'affaire :" class="oasice-edit-create-input">
      <b-form-input :id="`${getInputId}-${_uid}`"
                    type="text"
                    v-model="oasiceNumber"
                    autocomplete="off"
                    required></b-form-input>
    </b-form-group>
    <b-form-group>
      <b-btn text="Envoyer"
             type="submit"
             :form="`${getInputId}-form-${_uid}`"
             variant="primary">Envoyer</b-btn>
    </b-form-group>
  </b-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OasiceEditCreateInputType',
  props: {
  },
  data() {
    return {
      oasiceNumber: '',
    };
  },
  mounted() {
    // Access check
    if (!this.isAdmin() && !this.isAgent()) {
      this.$router.push({ name: 'dashboard' });
    }
  },
  computed: {
    ...mapGetters([
    ]),
    getInputId() {
      return 'oasice-edit-create-input';
    },
  },
  methods: {
    ...mapGetters([
      'getFormPatchUserError',
      'isAdmin',
      'isAgent',
    ]),
    editCreate(event) {
      event.preventDefault();
      event.stopPropagation();
      this.$store.commit('setGlobalSpinnerShow', true);
      this.$store.dispatch('createGet', { oasiceNumber: this.oasiceNumber })
        .then((response) => {
          // console.log(response.data);
          // Show success toast
          const toast = {
            show: true,
            message: `Affaire ${response.status === 201 ? 'créée' : 'récupérée'} avec succès !`,
            variant: 'success',
            duration: 3000,
          };
          this.$store.commit('setGlobalToaster', toast);
          this.$emit('enedisCaseRecovered', response.data);
        }, (error) => {
          if (error.status === 404) {
            if (typeof error.body.archived !== 'undefined') {
              // Show info error toast
              const toast = {
                show: true,
                message: `${error.body.message}`,
                variant: 'info',
                duration: 3000,
              };
              this.$store.commit('setGlobalToaster', toast);
            }
          }
        })
        .finally(() => {
          this.$store.commit('setGlobalSpinnerShow', false);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .oasice-edit-create-input-legend {
    font-size: 12px;
    font-style: italic;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/OasiceEditCreateInputType.vue